<template>
  <div id="lossesPage">
    <vs-row vs-type="flex" vs-w="12" class="mb-1">
      <global-filter
        ref="filterer"
        :tableOptions="tableOptions"
        :filterOptions="filterOptions"
        :filterChips="filterChips"
        :filterOptionNames="filterOptionNames"
        :isActive="isFilterActive"
        @saveOptions="saveOptions"
        @close="isFilterActive = false"
      />
      <vs-row
        id="panelHeaderRow"
        v-show="!isFilterActive"
        vs-type="flex"
        vs-w="12"
        vs-justify="space-between"
      >
        <vs-col
          id="panel-actions"
          vs-type="flex"
          class="w-auto"
          vs-justify="center"
        >
          <vs-row vs-type="flex" vs-w="12">
            <vs-col vs-type="flex" class="w-auto">
              <vx-tooltip text="Detaylı Filtereleme" position="top">
                <vs-button
                  @click="isFilterActive = !isFilterActive"
                  class="panel-action text-warning xlarge-button panel-action-box-shadow"
                  color="transparent"
                  icon-pack="pickicon"
                  icon="icon-pick-filter"
                >
                </vs-button>
              </vx-tooltip>
            </vs-col>
            <vs-col vs-type="flex" class="w-auto">
              <vx-tooltip text="Excel Export" position="top">
                <vs-button
                  @click="getExcel"
                  class="panel-action text-dark xlarge-button panel-action-box-shadow"
                  color="transparent"
                  icon-pack="feather"
                  icon="icon-download"
                >
                </vs-button>
              </vx-tooltip>
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col id="filter-chips" vs-type="flex">
          <vs-row
            vs-type="flex"
            vs-w="12"
            vs-justify="center"
            vs-align="center"
          >
            <vs-button
              id="clearFilterButton"
              v-if="filterChips.length > 0"
              @click="clearFilter"
              class="mr-2 bg-white text-danger panel-action-box-shadow"
              icon-pack="feather"
              icon="icon-slash"
              radius
              color="transparent"
            />
            <vs-col
              vs-type="flex"
              class="w-auto"
              v-for="(chip, index) in filterChips"
              :key="index"
            >
              <vs-chip
                color="white"
                class="panel-action-box-shadow px-1"
                @click="removeFilter(chip.col, index)"
                v-show="chip.value != ''"
                closable
              >
                <vs-row vs-tpye="flex" vs-w="12">
                  <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                    <span class="bold text-xsmaller text-dark">
                      {{ chip.name + " :" }}
                    </span>
                  </vs-col>
                  <vs-col vs-type="flex" class="w-auto ml-1" vs-align="center">
                    <span class="weight-600 italic text-xsmaller text-primary">
                      {{ chip.value }}
                    </span>
                  </vs-col>
                </vs-row>
              </vs-chip>
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col
          id="table-page-size"
          vs-type="flex"
          class="w-auto"
          vs-justify="flex-end"
        >
          <vs-dropdown
            vs-trigger-click
            class="bg-white cursor-pointer panel-action-box-shadow"
          >
            <div
              class="px-4 d-theme-border-grey-light d-theme-dark-bg cursor-pointer flex items-center justify-between text-small"
            >
              <span class="mr-2 page-size-dropdown-span"
                >{{ (currentPage + 1) * itemsPerPage - (itemsPerPage - 1) }}
                -
                {{
                  totalDataRow - (currentPage + 1) * itemsPerPage > 0
                    ? (currentPage + 1) * itemsPerPage
                    : totalDataRow
                }}
                of
                {{ totalDataRow }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage = 10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 15">
                <span>15</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 20">
                <span>20</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </vs-col>
      </vs-row>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12" id="lossDataList">
      <vs-row vs-type="flex" vs-w="12" class="my-1" id="lossDataListHeader">
        <vs-col
          vs-type="flex"
          vs-w="1"
          vs-justify="center"
          vs-align="center"
          class="p-1"
        >
          <vs-button
            class="p-1 bold text-smaller w-full"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'id' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('id')"
            >No
          </vs-button>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-w="2"
          vs-justify="center"
          vs-align="center"
          class="p-1"
        >
          <vs-button
            class="p-1 bold text-smaller w-full"
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'branch.Name' ? sortingHeadIcon : null
            "
            color="primary"
            type="flat"
            @click="setSortingOptions('branch.Name')"
            >Şube
          </vs-button>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-w="1"
          vs-justify="center"
          vs-align="center"
          class="p-1"
        >
          <vs-button
            class="p-1 bold text-smaller w-full"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'created' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('created')"
            >Tarih
          </vs-button>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-w="1"
          vs-justify="center"
          vs-align="center"
          class="p-1"
        >
          <vs-button
            class="p-1 bold text-smaller w-full"
            icon-pack="feather"
            color="primary"
            type="flat"
            >Saat
          </vs-button>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-w="2"
          vs-justify="center"
          vs-align="center"
          class="p-1"
        >
          <vs-button
            class="p-1 bold text-smaller w-full"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'user.Name' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('user.Name')"
            >Personel
          </vs-button>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-w="1"
          vs-justify="center"
          vs-align="center"
          class="p-1"
        >
          <vs-button
            class="p-1 bold text-smaller w-full"
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'lossReason.Name' ? sortingHeadIcon : null
            "
            color="primary"
            type="flat"
            @click="setSortingOptions('lossReason.Name')"
            >Sebep
          </vs-button>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-w="2"
          vs-justify="center"
          vs-align="center"
          class="p-1"
        >
          <vs-button
            class="p-1 bold text-smaller w-full"
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'description' ? sortingHeadIcon : null
            "
            color="primary"
            type="flat"
            @click="setSortingOptions('description')"
            >Açıklama
          </vs-button>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-w="1.5"
          vs-justify="center"
          vs-align="center"
          class="p-1"
        >
          <vs-button
            class="p-1 bold text-smaller w-full"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'price' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('price')"
            >Tutar
          </vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-w="0.5" vs-justify="center" vs-align="center">
        </vs-col>
      </vs-row>
      <vs-row
        vs-type="flex"
        vs-w="12"
        v-for="(loss, index) in losses"
        :key="index"
        class="lossRow mb-2 sale-box-shadow bg-white"
      >
        <div class="vs-row w-full pointer" @click="openLossEntries(index)">
          <vs-row
            vs-type="flex"
            vs-w="12"
            vs-justify="center"
            vs-align="center"
            class="py-1"
          >
            <vs-col
              vs-type="flex"
              vs-w="1"
              vs-justify="center"
              vs-align="center"
              class="p-1"
            >
              <span class="text-dark weight-600 text-smaller">
                {{ loss.id }}
              </span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-w="2"
              vs-justify="center"
              vs-align="center"
              class="p-1"
            >
              <span class="text-dark weight-600 text-smaller">
                {{ loss.branch.name }}
              </span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-w="1"
              vs-justify="center"
              vs-align="center"
              class="p-1"
            >
              <span class="text-dark weight-600 text-center text-smaller">
                {{ loss.date }}
              </span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-w="1"
              vs-justify="center"
              vs-align="center"
              class="p-1"
            >
              <span class="text-dark weight-600 text-center text-smaller">
                {{ loss.time }}
              </span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-w="2"
              vs-justify="center"
              vs-align="center"
              class="p-1"
            >
              <span class="text-dark weight-600 text-smaller">
                {{ loss.user.name }}
              </span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-w="1"
              vs-justify="center"
              vs-align="center"
              class="p-1"
            >
              <span class="text-dark weight-600 text-smaller">
                {{ loss.lossReason.name }}
              </span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-w="2"
              vs-justify="center"
              vs-align="center"
              class="p-1"
            >
              <span class="text-dark weight-600 text-smaller">
                {{ loss.description }}
              </span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-w="1.5"
              vs-justify="center"
              vs-align="center"
              class="p-1"
            >
              <span class="text-dark weight-600 text-smaller">
                {{ getLossTotalPrice(loss) }}
              </span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-w="0.5"
              vs-justify="center"
              vs-align="center"
            >
              <feather-icon
                v-if="!loss.isOpen"
                icon="ChevronDownIcon"
                svgClasses="h-6 w-6 bold"
              />
              <feather-icon
                v-else
                icon="ChevronUpIcon"
                svgClasses="h-6 w-6 bold"
              />
            </vs-col>
          </vs-row>
        </div>
        <transition name="slide-fade">
          <vs-row
            v-if="loss.isOpen"
            vs-type="flex"
            vs-w="12"
            vs-justify="center"
            vs-align="center"
            class="lossEntryDetails"
          >
            <vs-row
              vs-type="flex"
              vs-w="12"
              vs-justify="center"
              vs-align="center"
              class="lossEntryDetailHeaders"
            >
              <vs-col
                vs-type="flex"
                vs-w="4"
                vs-justify="center"
                vs-align="center"
                class="p-1"
              >
                <span class="text-primary text-smaller bold"> İsim </span>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-w="2"
                vs-justify="center"
                vs-align="center"
                class="p-1"
              >
                <span class="text-primary text-smaller bold"> Tür </span>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-w="2"
                vs-justify="center"
                vs-align="center"
                class="p-1"
              >
                <span class="text-primary text-smaller bold"> Miktar </span>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-w="2"
                vs-justify="center"
                vs-align="center"
                class="p-1"
              >
                <span class="text-primary text-smaller bold"> Birim </span>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-w="2"
                vs-justify="center"
                vs-align="center"
                class="p-1"
              >
                <span class="text-primary text-smaller bold"> Maaliyet </span>
              </vs-col>
            </vs-row>
            <vs-row
              vs-type="flex"
              vs-w="12"
              vs-justify="center"
              vs-align="center"
              class="lossEntryRow py-1"
              v-for="(entry, index) in loss.entries"
              :key="index"
            >
              <vs-col
                vs-type="flex"
                vs-w="4"
                vs-justify="center"
                vs-align="center"
                class="p-1"
              >
                <div v-if="entry.type == 1" class="w-full block text-center">
                  <vs-dropdown vs-custom-content vs-trigger-click>
                    <a class="flex items-center" href.prevent>
                      <span class="text-dark weight-600 text-smaller underline">
                        {{ entry.lossEntryProduct.productName }}
                      </span>
                    </a>
                    <vs-dropdown-menu>
                      <div class="w-auto p-1" style="max-width: 233px">
                        <span
                          class="block text-center text-smaller text-primary weight-600 mb-1"
                        >
                          Ürün İçeriği
                        </span>
                        <div
                          class="d-inline-block w-full border-bottom pb-1"
                          v-for="(rawMaterial, index) in entry.lossEntryProduct
                            .rawMaterials"
                          :key="index"
                        >
                          <span class="text-xsmall text-dark weight-500">
                            {{ rawMaterial.recipeStep.unitPartQuantity }}
                          </span>
                          <span class="text-xsmall text-primary bold">
                            {{ rawMaterial.rawMaterial.unit.name }}
                          </span>
                          <span class="text-xsmall text-dark weight-500">
                            {{ rawMaterial.rawMaterial.name }}
                          </span>
                        </div>
                      </div>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                  <span
                    class="block text-dark weight-500 text-xsmall"
                    v-for="(extra, index) in entry.lossEntryProduct.extras"
                    :key="index"
                  >
                    x{{ extra.quantity + " " + extra.productExtra.name }}
                  </span>
                </div>
                <span v-else class="text-dark weight-600 text-smaller">
                  {{ entry.stock.rawMaterial.name }}
                </span>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-w="2"
                vs-justify="center"
                vs-align="center"
                class="p-1"
              >
                <span
                  v-if="entry.type == 1"
                  class="text-dark weight-600 text-smaller"
                >
                  Ürün
                </span>
                <span v-else class="text-dark weight-600 text-smaller">
                  Hammadde
                </span>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-w="2"
                vs-justify="center"
                vs-align="center"
                class="p-1"
              >
                <span class="text-dark weight-600 text-smaller">
                  {{ entry.lossQuantity }}
                </span>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-w="2"
                vs-justify="center"
                vs-align="center"
                class="p-1"
              >
                <span
                  v-if="entry.type == 1"
                  class="text-dark weight-600 text-smaller"
                >
                  Adet
                </span>
                <span v-else class="text-dark weight-600 text-smaller">
                  {{ entry.stock.unit.name }}
                </span>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-w="2"
                vs-justify="center"
                vs-align="center"
                class="p-1"
              >
                <span class="text-dark weight-600 text-smaller">
                  {{ $toCurrency(entry.price) }}
                </span>
              </vs-col>
            </vs-row>
          </vs-row>
        </transition>
      </vs-row>
    </vs-row>
    <div class="d-flex w-full">
      <span class="ml-auto bold text-primary"
        >{{ $toCurrency(totalPagePrice) }} TL</span
      >
      <span class="bold text-dark">/ {{ $toCurrency(totalPrice) }} TL</span>
    </div>
    <pagination-default
      :setCurrentPage="tableOptions.pageIndex"
      :totalLenght="calculatePageLength"
      @currentPage="getCurrentPage"
    ></pagination-default>
  </div>
</template>

<script>
import GlobalFilter from "../GlobalFilter";
import moduleLoss from "@/store/loss/moduleLoss.js";
import PaginationDefault from "../PaginationDefault";
import { getLossExcel } from "@/api/Loss.js";

export default {
  components: {
    PaginationDefault,
    GlobalFilter,
  },
  data() {
    return {
      tableOptions: {},
      sortingHeadIcon: "",
      sortingHeadIconBool: 1,
      currentPage: 0,
      itemsPerPage: 10,

      isFilterActive: false,
      filterOptions: [
        "dateRange",
        "price",
        "timeRange",
        "branch",
        "lossDescription",
        "lossReason",
        "product",
        "extra",
        "rawMaterial",
        "personal",
      ],
      filterOptionNames: [
        "Tarih",
        "Tutar",
        "Saat",
        "Şube",
        "Açıklama",
        "Sebep",
        "Ürün",
        "Ekstra",
        "Hammadde",
        "Personel",
      ],
      filterChips: [],
    };
  },
  computed: {
    losses() {
      return this.$store.getters["loss/getLosses"];
    },
    totalDataRow() {
      return this.$store.getters["loss/getTotalDataRow"];
    },
    totalPrice() {
      return this.$store.getters["loss/getTotalPrice"];
    },
    totalPagePrice() {
      return this.$store.getters["loss/getTotalPagePrice"];
    },
    calculatePageLength() {
      let mod = this.totalDataRow % this.itemsPerPage;
      return mod > 0
        ? (this.totalDataRow - mod) / this.itemsPerPage + 1
        : this.totalDataRow / this.itemsPerPage;
    },
  },
  methods: {
    getExcel() {
      getLossExcel(this.tableOptions)
        .then((res) => {
          if (res && res.status == 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            let now = this.$now.date();
            link.setAttribute(
              "download",
              "Gider Raporu" +
                now.getDate() +
                " " +
                this.$months()[now.getMonth()].name +
                " " +
                now.getFullYear() +
                ".xlsx"
            );
            document.body.appendChild(link);
            link.click();

            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Excel Export Başarılı !",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Excel Export İşlemi Başarısız !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    getLossTotalPrice(loss) {
      var price = 0;
      loss.entries.forEach((x) => {
        price += x.price;
      });
      return this.$toCurrency(price, 2);
    },
    openLossEntries(lossIndex) {
      this.$store.dispatch("loss/openLossEntries", lossIndex);
    },
    saveOptions(filterOptions, filterChips) {
      this.isFilterActive = false;
      if (_.isEqual(this.tableOptions, filterOptions)) return;
      this.tableOptions = _.cloneDeep(filterOptions);
      this.filterChips = _.cloneDeep(filterChips);
    },
    clearFilter() {
      this.tableOptions = {
        sortBy: "Created",
        sortDirection: "desc",
        pageIndex: 0,
        pageSize: this.itemsPerPage,
        dateRange: {
          startDate: this.$now.date(),
          endDate: this.$now.date(),
        },
        timeRange: {
          startTime: null,
          endTime: null,
        },
        price: {
          min: null,
          max: null,
        },
        product: null,
        extra: null,
        rawMaterial: null,
        branch: this.$currentUser.branch,
        personal: null,
        lossDescription: null,
        lossReason: null,
      };
      if (!this.$isCenterBranch()) {
        if (!this.$isRegionalCenterBranch()) {
          let branchPropIndex = this.filterOptions.indexOf("branch");
        this.filterOptions.splice(branchPropIndex, 1);
        this.filterOptionNames.splice(branchPropIndex, 1);
        delete this.tableOptions["branch"];
        }
        
      }
      this.filterChips.length = 0;
    },
    removeFilter(col, index) {
      this.tableOptions[col] = null;
      this.filterChips.splice(index, 1);
    },
    getCurrentPage(currentx) {
      this.currentPage = currentx - 1;
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
      val == false ? (this.selected = "") : null;
    },
    getLossList() {
      if (this.$isRegionalCenterBranch()) {
        this.$store
        .dispatch("loss/fetchDataListItemsLossForDealer", this.tableOptions)
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: error,
          });
        });
      } else {
        this.$store
        .dispatch("loss/fetchDataListItemsLoss", this.tableOptions)
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: error,
          });
        });
      }
      
    },
    setSortingOptions(val) {
      if (this.tableOptions.sortBy != val) this.sortingHeadIconBool = 1;
      this.tableOptions.sortBy = val;
      switch (this.sortingHeadIconBool) {
        case 1:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-up";
          break;
        case 2:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-down";
          break;
        case 3:
          this.sortingHeadIconBool = 1;
          this.sortingHeadIcon = "";
          this.tableOptions.sortBy = "";
      }
    },
  },
  created() {
    if (!moduleLoss.isRegistered) {
      this.$store.registerModule("loss", moduleLoss);
      moduleLoss.isRegistered = true;
    }
    this.clearFilter();
    if (!this.$isCenterBranch() && !this.$isRegionalCenterBranch()) {
      let branchPropIndex = this.filterOptions.indexOf("branch");
      this.filterOptions.splice(branchPropIndex, 1);
      this.filterOptionNames.splice(branchPropIndex, 1);
      delete this.tableOptions["branch"];
    }
  },
  watch: {
    tableOptions: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.getLossList();
        });
      },
    },
    currentPage: function (val) {
      this.tableOptions.pageIndex = val;
    },
    sortingHeadIconBool: function () {
      switch (this.sortingHeadIconBool) {
        case 1:
          this.tableOptions.sortDirection = "";
          break;
        case 2:
          this.tableOptions.sortDirection = "asc";
          break;
        case 3:
          this.tableOptions.sortDirection = "desc";
          break;
      }
      this.currentPage = 0;
      this.tableOptions.pageIndex = this.currentPage;
    },
    itemsPerPage: function (val) {
      this.currentPage = 0;
      this.tableOptions.pageSize = val;
      this.tableOptions.pageIndex = this.currentPage;
    },
  },
};
</script>

<style>
.lossEntryDetailHeaders {
  background-color: rgba(var(--vs-danger), 0.1) !important;
  border-top: 1px solid rgba(var(--vs-danger), 0.1);
  border-bottom: 1px solid rgba(var(--vs-danger), 0.1);
}

.lossEntryDetails {
  border: 1px solid #00000030;
  border-top: none;
}

.lossEntryRow {
  border-bottom: 1px solid #00000020;
}

#lossDataList {
  max-height: calc(100vh - 210px);
  overflow-y: auto;
}

#lossesPage .vs-button-success:not(.vs-button-line),
.vs-button-danger:not(.vs-button-line),
.vs-button-primary:not(.vs-button-line) {
  color: rgba(var(--vs-primary), 1) !important;
}
</style>
